(function initGeoRedirect() {
    var storedCountryCode = localStorage.getItem('countryCode');

    if (storedCountryCode) {
        checkLocationRedirect(storedCountryCode);
        return;
    }

    jQuery.getJSON('https://json.geoiplookup.io', function (data) {
        if (!data || !data.country_code) {
            return;
        }

        var countryCode = data.country_code;
        var formattedCountryCode = 'en-' + countryCode.toLowerCase();
        localStorage.setItem('countryCode', formattedCountryCode);
        checkLocationRedirect(formattedCountryCode);
    });
})();


// Slug-to-filename map for country flag images
const countryFlagMap = {
    'united-kingdom': 'unitedkingdom.svg',
    'australia': 'australia.svg',
    'canada': 'canada.svg',
    'new-zealand': 'newzealand.svg',
    'united-states': 'unitedstates.svg',
};

function updateLangBtnFlag(countrySlug, countryName) {
    const flagImg = document.querySelector('#lang-btn .lang-btn-flag');
    const nameEl = document.querySelector('#lang-btn .lang-btn-name');
    const basePath = (typeof afp_vars !== 'undefined' && afp_vars.country_flag_base) ? afp_vars.country_flag_base : '';

    if (flagImg && basePath) {
        const file = countryFlagMap[countrySlug] || 'world.svg';
        flagImg.src = basePath + file;
        flagImg.alt = (countryName || countrySlug) + ' flag';
    }
    if (nameEl && countryName) {
        nameEl.textContent = countryName;
    }

    // Update active state on list items
    document.querySelectorAll('.wai_country').forEach(function (li) {
        li.classList.remove('wai_country__active');
        if (li.dataset.countrySlug === countrySlug) {
            li.classList.add('wai_country__active');
        }
    });
}

// On page load, restore the #lang-btn flag from localStorage
(function restoreLangBtnFlag() {
    var savedSlug = localStorage.getItem('countrySlug');
    var savedName = localStorage.getItem('countryName');
    if (savedSlug) {
        // Defer until DOM is ready so the #lang-btn elements exist
        var apply = function () { updateLangBtnFlag(savedSlug, savedName || ''); };
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', apply);
        } else {
            apply();
        }
    }
})();

// On page load, check for countryCode in localStorage and handle redirect
var storedCountryCode = localStorage.getItem('countryCode');
if (storedCountryCode !== null && storedCountryCode !== undefined) {
    checkLocationRedirect(storedCountryCode);
}

// Handle the country selection and save to local storage (for .wai_country buttons)
const countryButtons = document.querySelectorAll('.wai_country');
if (countryButtons.length) {
    countryButtons.forEach((button) => {
        button.addEventListener('click', function (event) {
            const li = event.currentTarget;
            const selectedValue = li.dataset.countryCode;
            const countrySlug = li.dataset.countrySlug || '';
            const countryName = li.dataset.countryName || '';
            if (!selectedValue) {
                console.warn('Missing data-country-code attribute.');
                return;
            }

            // Update the #lang-btn icon to reflect the selected country
            updateLangBtnFlag(countrySlug, countryName);

            // Remove popup class if present (optional, for parity with old logic)
            document.body.classList.remove('geo-redirect-open');
            const popup = document.getElementById('geoLocationPopup');
            if (popup) popup.style.display = 'none';

            // Persist selection for restore on page load
            localStorage.setItem('countryCode', selectedValue);
            localStorage.setItem('countrySlug', countrySlug);
            localStorage.setItem('countryName', countryName);
            checkLocationRedirect(selectedValue);
        });
    });
}

function checkLocationRedirect(userCountryCode) {
    var alternativeURL = window.redirectURL;
    var otherCountry = window.otherCountry ?? false;
    var defaultCountry = window.defaultCountry ?? false;

    // If override_redirect is set, never redirect
    if (localStorage.getItem('override_redirect') === 'true') {
        return;
    }

    if (!userCountryCode || !alternativeURL) {
        return;
    }

    if (defaultCountry && (userCountryCode === 'en-' + defaultCountry.toLowerCase())) {
        // No action needed - already on the default site
        return;
    }

    if (otherCountry && (userCountryCode === 'en-' + otherCountry.toLowerCase())) {
        var currentURL = window.location.href.split('#')[0];
        var targetURL = alternativeURL.split('#')[0];

        if (currentURL !== targetURL) {
            window.location.href = alternativeURL;
        }
    }
}

function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === 'undefined' ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}

console.log(getUrlParameter('redirect'));
if (getUrlParameter('redirect') === 'no') {
    localStorage.setItem('override_redirect', 'true');
} else if (getUrlParameter('redirect') === 'yes') {
    localStorage.setItem('override_redirect', 'false');
}